// The house number an owner typed into the address box.
// ============================================================================
// Owner, 2026-08-08: typed "ანა პოლიტკოვსკაიას ქუჩა 46", picked the suggestion, and
// the number box came back empty — "why it dont pick number from search?"
//
// ⚠️ This does NOT reverse the rule that a search pick never claims a house number.
// That rule is about the PIN: our gazetteer holds one coordinate per street, so
// reading a number back off it would invent one. A number the human typed is not an
// inference at all — it is their answer, and dropping it just loses data they gave us.
// Derived from the TYPED TEXT, never from the pin.
//
// ⚠️ DEPENDENCY-FREE BY CONTRACT — the public fill bundle imports it. Same rule as
// districtModel: pure module, no db, no i18n, no components.
// ============================================================================

// Takes the last number-ish token — "46", "46ა", "12/3" — and refuses one that belongs
// to the street's own name, because plenty of real ones do: ანაპის 414-ე დივიზიის ქუჩა,
// 76-ე ქუჩა. Without that check, picking "76-ე ქუჩა" would silently claim the owner
// lives at number 76.
export function houseNumberFromQuery(text, streetName = '') {
  const raw = String(text || '').trim()
  if (!raw) return null
  const matches = [...raw.matchAll(/(?:^|[\s,])(\d+\s*(?:\/\s*\d+)?\s*[\p{L}]?)(?=[\s,]|$)/gu)]
  if (!matches.length) return null
  const cand = matches[matches.length - 1][1].replace(/\s+/g, '')
  if (!cand || cand.length > 12) return null
  const name = String(streetName || '')
  // ⚠️ NUMERIC BOUNDARIES, not a substring test (2026-08-19). `name.includes(cand)` also
  // refused a number that merely appears INSIDE a longer one in the name: house 1 on
  // "მე-11 მიკრორაიონი" was dropped because "მე-11" contains "1", and house 4 on
  // "ანაპის 414-ე დივიზიის ქუჩა" because "414" contains "4". Both are real Rustavi/Tbilisi
  // addresses, and both silently lost a number the owner had typed — the exact failure this
  // module was written to fix, in the other direction.
  // Comparing the LEADING DIGITS with a non-digit on each side keeps the guard's real job
  // ("76-ე ქუჩა" still refuses 76) while letting a genuine house number through.
  const lead = (cand.match(/^\d+/) || [''])[0]
  if (name && lead && new RegExp(`(^|\\D)${lead}(\\D|$)`).test(name)) return null
  return cand
}
